export const USER_PROFILE = {
    full_name: '',
    avatar: '',
    role: '',
    user_id: '',
    is_ochs: '',
    is_verihealth: ''
};
